import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-information-modal',
  templateUrl: './information-modal.component.html',
  styleUrls: ['./information-modal.component.scss'],
})
export class InformationModalComponent  implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() icon: string;
  @Input() img: string;
  @Input() text: string;
  @Input() btnText: string;
  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {}

  get hasDynamicContent(): boolean {
    return !!this.message?.trim();
  }

    dismiss() {
    this.modalCtrl.dismiss();
  }

}
